module.exports = __webpack_public_path__ + "img/miyazaki.a6f72b9c.jpg";